if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      let radioSize = null;
      let formSection = this.closest(".js-no-insert-check");
      let radioParent = this.closest(".product__info-main_content");
      let radioInput = radioParent.querySelector('input[name="Type"]:checked');
      let insertId = radioInput?.dataset.variantId;
      let insertType = radioInput?.value;
      let packageCheck = document.body.classList.contains("template-product-pillow-package");
      let addToCartBtn = this.querySelector(".product-form__submit");
      radioSize = radioInput?.dataset.variantSize;

      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      let config = fetchConfig('javascript');
      if (formSection || packageCheck) {
        delete config.headers['Accept'];
        config.headers['Content-Type'] = 'application/json';
      } 
      else {
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];        
      }

      let formData = new FormData(this.form);
      let productId = formData.get('id');
      let productQty = parseInt(formData.get('quantity'));

      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      let productInfo = this.closest(".product__info-main_content");
      let packageWrapper = productInfo.querySelector("pillow-package-wrapper")

      let items = [];

      if (packageWrapper && typeof packageWrapper.getCartData === 'function') {
        items = packageWrapper.getCartData();
      }

      if (packageCheck && packageWrapper) {
        let errorNote = packageWrapper.querySelector('.js-quantity-note');
        let variantSelected = packageWrapper.querySelector('input.js-insert-radio:checked')
        let noInsertSelected = packageWrapper.querySelector('input.js-package-no-insert:checked')
        let variantType = variantSelected?.value;
        let totalQty = 0;
        if (!errorNote) return;

        let show = false;

        if (items.length > 0) {
          items.forEach(item => {
            let qty  = Number(item.quantity);
            totalQty += qty;
          });
          if (variantType != null) {
            if ((variantType.includes('Faux') || variantType.includes('Poly')) && totalQty < 3) {
              // show = true;
              // errorNote.classList.toggle('visibility-hidden', !show);
              // this.submitButton.classList.remove('loading');
              // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              // this.querySelector('.loading-overlay__spinner').classList.add('visibility-hidden');
              this.scrollToErrorNote();
              // setTimeout(() => {
              //   errorNote.classList.add('visibility-hidden');
              // }, 5000);
              return;
            }
          }
          if (noInsertSelected && totalQty < 2) {
            // show = true;
            // errorNote.classList.toggle('visibility-hidden', !show);
            // this.submitButton.classList.remove('loading');
            // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            // this.querySelector('.loading-overlay__spinner').classList.add('visibility-hidden');
            this.scrollToErrorNote();
            // setTimeout(() => {
            //   errorNote.classList.add('visibility-hidden');
            // }, 5000);
            return;
          }
        }
        
        formData = {
          'items': items,
          "sections": this.cart.getSectionsToRender().map((section) => section.id),
          "sections_url": window.location.pathname
        };
        formData.items.reverse();

        config.body = JSON.stringify(formData);
      } else if (formSection) {
        formData = {
          'items': [{
            'id': productId,
            'quantity': productQty,
            properties: {
              'Insert Type': insertType
            }
          }
        ],
        "sections": this.cart.getSectionsToRender().map((section) => section.id),
        "sections_url": window.location.pathname
        };

        if (insertId) {
          formData.items.push({
            id: insertId,
            quantity: productQty
          });
        }
        if (radioSize) {
          let productItem = formData.items.find(item => item.id === productId);
          productItem.properties['Insert Size'] = radioSize;
        }
  
        formData.items.reverse();

        config.body = JSON.stringify(formData);
      } else {
        config.body = formData
      }

      let routeUrl = (formSection || packageCheck) ? window.Shopify.routes.root + 'cart/add.js' : `${routes.cart_add_url}`;

      fetch(routeUrl, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: productId, errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: productId});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    scrollToErrorNote() {
      const errorNote = document.querySelector('.js-quantity-note');
      if (!errorNote) return;

      errorNote.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  });
}
